/**
 * Checks if the text contains unordered or ordered list or blockquote markdown patterns
 */
export const containsListOrBlockquoteMarkdown = (text?: string): boolean => {
  if (!text) {
    return false;
  }

  // Handle escaped newlines by replacing them with actual newlines
  const normalizedText = text.replace(/\\n/g, '\n');

  // Check for patterns like "- item", "1. item", and "> text" at the beginning of a line
  const unorderedListPattern = /^(?:[\r\n]|^)\s*[-*+]\s+.+/m;
  const orderedListPattern = /^(?:[\r\n]|^)\s*\d+\.\s+.+/m;
  const blockquotePattern = /^(?:[\r\n]|^)\s*>\s+.+/m;

  return (
    unorderedListPattern.test(normalizedText) ||
    orderedListPattern.test(normalizedText) ||
    blockquotePattern.test(normalizedText)
  );
};

/**
 * Checks if the text contains non-inline markdown (headers, lists, blockquotes) patterns
 */
export const containsNonInlineMarkdown = (text?: string): boolean => {
  if (!text) {
    return false;
  }

  const normalizedText = text.replace(/\\n/g, '\n');
  return /^#{1,3}\s+.+/m.test(normalizedText) || containsListOrBlockquoteMarkdown(normalizedText);
};
